import { render, staticRenderFns } from "./ExtrusionAppointmentModal.vue?vue&type=template&id=d70b2060&scoped=true&"
import script from "./ExtrusionAppointmentModal.vue?vue&type=script&lang=js&"
export * from "./ExtrusionAppointmentModal.vue?vue&type=script&lang=js&"
import style0 from "./ExtrusionAppointmentModal.vue?vue&type=style&index=0&id=d70b2060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70b2060",
  null
  
)

export default component.exports